import axios from 'axios';

// const sliderApi = axios.create({
//   baseURL: "https://backend.penpencilbd.com/wp-json/vthea-slider/v1/",
// });

// export const getSlider = () => sliderApi.get('sliders');
// export const bannerService = {
//   async getSlider() {
//     console.log("Fetching slider images.. sssss.");
//     return axios.get('https://backend.penpencilbd.com/wp-json/vthea-slider/v1/sliders');
//     // try {
//     //     console.log("Fetching slider images.. ccccc.");
//     //     const response = await getSlider();
//     //     return response.data;
//     // } catch (error) {
//     //     console.log("Fetching slider images.. eeeeeee.");
//     //   console.error("Error fetching slider images:", error);
//     //   throw error;
//     // }
//   }
// };      

export const bannerService = {
  async getSlider() {
    try {
    //   console.log("Fetching slider images...");
      const response = await axios.get('https://backend.penpencilbd.com/wp-json/vthea-slider/v1/sliders');
      return response;
    } catch (error) {
    //   console.error("Error fetching slider images:", error);
      throw error;
    }
  }
};
